const WORDS = ["STRATEGIA DI COMUNICAZIONE", "SOCIAL MEDIA", "FOTO & VIDEO", "ADV", "STRATEGIA DI BUSINESS"];

export const Marquee = () => {
  const row = (
    <div className="flex shrink-0 items-center">
      {WORDS.map((w, i) => (
        <span key={w} className="flex items-center">
          <span className={`whitespace-nowrap px-6 font-serif text-5xl md:px-10 md:text-8xl ${i % 2 ? "stroke-text" : "text-ink"}`}>{w}</span>
          <img src="/img/mark-dark.png" alt="" className="h-8 w-auto opacity-40 md:h-12" />
        </span>
      ))}
    </div>
  );
  return (
    <section aria-label="Cosa facciamo" className="overflow-hidden border-y border-ink/10 py-10 md:py-14" data-testid="marquee">
      <div className="flex w-max animate-marquee" aria-hidden="true">
        {row}
        {row}
      </div>
    </section>
  );
};
